module.exports = __webpack_public_path__ + "img/1f_r_tonya@2x.11797424.jpg";